module.exports = "## It is super simple to use\r\n\r\nImage editing doesn’t have to be a rocket science. We built our editor with ease of use in mind. Editing a photo for the correct style and adjusting it to your artistic needs shouldn’t take more than 10 seconds! \r\n\r\nGive it a try and you will love the simplicity of our Image editor. We support both mobile and Desktop users, so give it a try regardless of your device."


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/PhotoEditor/photo-editor-section-four.md
// module id = 1168
// module chunks = 0